import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import dayjs from "config/dayjs"
import config from "./config"
import compact from "lodash/compact"

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const basicNS = ["imdf", "common", "error"]
const extensionNames = config("venueExtension")
const i18nNameSpace = config("i18nNameSpace", "common")
const appType = config("appType")
const ns = compact([i18nNameSpace, ...extensionNames, ...basicNS])
const fallbackNS = compact([...extensionNames, "imdf", "common"])
const loadPath =
  appType === "webapp"
    ? "/locales/{{lng}}/{{ns}}.json"
    : "./locales/{{lng}}/{{ns}}.json"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    detection: {
      order: ["localStorage", "navigator"],
    },
    fallbackLng: "en",
    ns,
    load: "languageOnly",
    defaultNS: i18nNameSpace,
    fallbackNS,
    backend: {
      loadPath,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
  })

i18n.on("languageChanged", function (lng) {
  dayjs.locale(lng)
})

export default i18n
